import { z } from 'zod';
import { subscriptionDocumentInputSchema } from './subscriptionDocument.js';
import { subscriptionPredecessorSchema } from './subscriptionPredecessor.js';
import { subscriptionSaleTypeSchema } from './subscriptionSaleType.js';
export const subscriptionInfoFields = {
    saleType: subscriptionSaleTypeSchema,
    partnerContactId: z.int().positive().nullish(),
    ticketId: z.int().positive().nullish(),
    predecessor: subscriptionPredecessorSchema.nullish(),
    // A calendar day. Only accepted while the subscription has not been billed yet.
    agreedStartAt: z.coerce.date().nullish(),
    salesAssigneeId: z.int().positive().nullish(),
    telesalesAssigneeId: z.int().positive().nullish(),
    comment: z.string().nullish(),
};
// Only part of the commercal information is editable here.
export const subscriptionInfoSchema = z.object({
    ...subscriptionInfoFields,
    // Empty when removing all documents.
    documents: subscriptionDocumentInputSchema.array(),
});
